import { Selection } from "@nextui-org/react";
import { ComponentType, SVGProps } from "react";
import { FeatureName } from "@/shared/config/feature-access";


export type NavItemPermissions = {
  isTeamAdmin?: boolean;
  isTeamMember?: boolean;
  isTeamOrgAdmin?: boolean;
  canAccessZaniaAccurateResponse?: boolean;
  canAccessZaniaRiskAssessment?: boolean;
  canAccessZaniaGapAssessment?: boolean;
  canAccessZaniaVendorAssessment?: boolean;
  canAccessZaniaQaAssessment?: boolean;
  canAccessZaniaAskAi?: boolean;
};

// Child item type for accordion sub-items
export interface NavItemChild {
  title: string;
  path: string;
  tabKey?: string;
}

export interface NavItemData {
  title: string | JSX.Element;
  label?: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  path: string;
  canAccess?: (permissions: NavItemPermissions) => boolean | undefined;
  featureName?: FeatureName;
  // Accordion support
  children?: NavItemChild[];
  // Placeholder items (UI only, no navigation)
  isPlaceholder?: boolean;
}

export interface AgentLogStepsData {
  id: number;
  completed: boolean;
  title: string;
  isCurrent: boolean;
  description: string[];
  isWaiting: boolean;
}

export interface AgentLogStepsStateData {
  riskAssessmentTab: Selection | "1" | "2" | "3" | "4" | "5";
  doraAssessmentTab: Selection | "1" | "2" | "3" | "4" | "5";
  questionnaireTab: Selection | "1" | "2" | "3" | "4" | "5" | "6";
  stepData: AgentLogStepsData[] | [];
  completedSteps: number;
  isOpen: boolean;
}

export enum AgentConsoleNavigation {
  riskAssessment = "agent/risk-assessment",
  doraAssessment = "agent/gap-assessment",
  questionnaire = "agent/questionnaire",
}

export enum AgentConsoleStepType {
  riskAssessment = "riskAssessment",
  doraAssessment = "doraAssessment",
  questionnaire = "questionnaire",
}

export enum AgentLogId {
  Id1 = 1,
  Id2 = 2,
  Id3 = 3,
  Id4 = 4,
  Id5 = 5,
  Id6 = 6,
}
